import { Component, OnInit, OnDestroy, Inject, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from '../order-items-util.service';
import { OrderItemsDialogsService } from '../order-items-dialogs.service';

import * as _ from 'lodash';
declare const $: any;

@Component({
    selector: 'app-group-sale',
    templateUrl: './group-sale.component.html',
    styleUrl: './group-sale.component.scss',
    standalone: false
})
export class GroupSaleComponent {
	prevDialogPosition;
	$storage;
	catalog;
	offerGroup: any;
	gropMode = null;
	isSummary: boolean = false;
	isPresale: boolean = false;
	isMultiSelection: boolean = false;
	nextCaption: string = 'TD.not_interested';
	hasNext: boolean = false;
	hideNext: boolean = false;
	hasCancel: boolean = false;
	offerCounters;
	deckClass = 'cols_3';
	closing: boolean = false;
	closed: boolean = true;
	wasOfferSelected: boolean = false;
	upsaleType: string;

	constructor(
		public dialogRef: MatDialogRef<GroupSaleComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private zone: NgZone,
		public appService: AppService,
		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
		public orderDialogs: OrderItemsDialogsService,
	) {
		this.offerGroup = this.data.group;
		switch (this.data.mode) {
			case "summary":
				this.isSummary = true;
				this.nextCaption = 'TD.payup';
				this.hasNext = true;
				this.upsaleType = 'prePayment';
				break;
			case "presale":
				this.isPresale = true;
				this.nextCaption = 'TD.not_interested_alt'; //this.offerGroup.requirePreSelection ? 'not_interested' : 'not_interested_alt';
				this.hasCancel = this.offerGroup.requirePreSelection;
				this.hasNext = true;
				this.upsaleType = 'preOfferSelection';
				break;
			default:
				this.upsaleType = 'afterOfferSelection';
				break;
		}

		this.isMultiSelection = this.data.mode != 'presale' && this.offerGroup.enableMultiSelection == true;
		//this.isMultiSelection = true;

		this.$storage = this.orderService.$storage;
		this.offerCounters = this.$storage.order.offerCounters;
		this.catalog = this.$storage.catalog;
		let offersLength = this.offerGroup.offers.length;
		let displayCols = Math.min(offersLength, 3);
		this.deckClass = `cols_${displayCols}`;

		let gridSize = this.offerGroup.grid_size;
		if (gridSize) {
			let cols = gridSize.replace('cols_', '');
			if (!isNaN(cols) && Number(cols) <= offersLength) {
				this.deckClass = gridSize;
			} else if (offersLength > 1) {
				this.deckClass = `${gridSize} _center`;
			}
		}
	}

	selectOffer(_offer, ev) {
		if (this.closing) return;
		if (ev) ev.stopPropagation();
		if (_offer._disabled) {
			this.appService.alert({ content: this.appService.translate("ITEM_OUT_OF_STOCK_MESSAGE", { count: _offer.stock }) });
			return;
		}
		this.orderService.validateOrderLimit(1, _offer.price).then(() => {
			let enableQuickAdd = _offer.enableQuickAdd && !_offer._offer?.forceOfferEdit;
			if (!enableQuickAdd) {
				this.editOffer(_offer);
			} else {
				this.selectQuickOffer(_offer);
			}
		})
	}

	selectQuickOffer(_offer) {
		if (_offer._disabled) {
			this.appService.alert({ content: this.appService.translate("MESSAGES.ITEM_OUT_OF_STOCK_MESSAGE", { name: _offer.name }) });
			return;
		}

		var viewItem = _.cloneDeep(_offer);
		this.orderUtils.prepareViewItem(this.$storage.catalog, viewItem);
		this.orderUtils.prepareSelectItem(this.$storage.catalog, viewItem);

		if (!this.orderUtils.validateOffer(viewItem)) {
			this.editOffer(_offer);
			return;
		}

		if (_offer.isWeight && _offer.baseUnits) {
			viewItem.total = viewItem.viewPrice;
		} else {
			viewItem.total = viewItem.price;
			if (viewItem._item && viewItem._item._addPrice) {
				viewItem.total += viewItem._item._addPrice;
			}
		}
		viewItem.quantity = 1;
		this.handleAddOffer(_offer, viewItem);
	}

	editOffer(_offer) {
		this.orderDialogs.openOfferDialog(_offer).then(result => {
			if (result) {
				this.handleAddOffer(_offer, result["viewItem"], _.get(result, 'viewItem.total'));
			}
		});
	}

	handleAddOffer(baseOffer, offerToAdd, newTotal?) {
		this.orderUtils.animateAddToBasket_alt(`#boffer_${baseOffer._id}`).then(o => {
			this.orderService.addToBasket(offerToAdd);
			this.wasOfferSelected = true;
			if (!this.isMultiSelection) this.closeApplyDialog(baseOffer);
			else this.nextCaption = this.nextCaption == 'TD.payup' ? 'TD.payup' : 'TD.continue';
		});
	}

	closeApplyDialog(_offer) {
		this.closing = true;
		this.dialogRef.close({
			mode: 'continue',
			viewItem: _offer,
			wasOfferSelected: this.wasOfferSelected
		});
	}


}
